// Lib
import React from 'react';
import { useSelector } from 'react-redux';

// Selectors
import { getPlatformDetailsSelector } from '../../platform/platformSelector';
import { getCurrentUserUsedPlatforms } from '../../user/currentUserSelector';

// Components
import QuickNotesDownloadMobileAppPlaceholder from './QuickNotesDownloadMobileAppPlaceholder';

// Constants
import { PLATFORMS } from '../../user/userConstants';
import { MilanoteApplicationMode } from '../../../common/platform/platformTypes';

// Styles
import './QuickNotesEmptyPlaceholder.scss';

const QuickNotesEmptyPlaceholder = (): React.ReactElement => {
    const platformDetails = useSelector(getPlatformDetailsSelector);
    const currentUserUsedPlatforms = useSelector(getCurrentUserUsedPlatforms);

    const isMobileAppMode = platformDetails.appMode === MilanoteApplicationMode.mobile;
    if (isMobileAppMode) {
        const imageUri = require('../header/workspaceToolsHeader/quickNotes/popup/images/quick-notes-empty-mobile.png');

        return (
            <div className="QuickNotesEmptyPlaceholder">
                <div className="QuickNotesEmptyTextPlaceHolder">
                    <div className="quick-notes-placeholder-image">
                        <img src={imageUri} draggable={false} />
                    </div>
                    <span className="quick-notes-placeholder-text">
                        Notes you add here will be synced to
                        <br />
                        Milanote on your desktop computer
                    </span>
                </div>
            </div>
        );
    }

    const hasUserUsedMobileApps =
        currentUserUsedPlatforms.includes(PLATFORMS.IPHONE) || currentUserUsedPlatforms.includes(PLATFORMS.ANDROID);
    if (hasUserUsedMobileApps) {
        return (
            <div className="QuickNotesEmptyPlaceholder">
                <div className="QuickNotesEmptyTextPlaceHolder">
                    <span className="quick-notes-placeholder-text">
                        Anything you add to Quick Notes
                        <br />
                        on your phone will appear here
                    </span>
                </div>
            </div>
        );
    }

    return <QuickNotesDownloadMobileAppPlaceholder platformDetails={platformDetails} />;
};

export default QuickNotesEmptyPlaceholder;
